module.exports = __webpack_public_path__ + "./images/3eeffd7afd77279ede8b6054c8dc4338.webp";